import axios from 'axios';
import { API, authHeaders } from './client';

export const getSocials = () =>
  axios.get(`${API}/social`).then(r => r.data);

export const createSocial = (token, data) =>
  axios.post(`${API}/social`, data, authHeaders(token)).then(r => r.data);

export const updateSocial = (token, id, data) =>
  axios.put(`${API}/social/${id}`, data, authHeaders(token)).then(r => r.data);

export const deleteSocial = (token, id) =>
  axios.delete(`${API}/social/${id}`, authHeaders(token)).then(r => r.data);

export const toggleSocial = (token, id) =>
  axios.put(`${API}/social/${id}/toggle`, {}, authHeaders(token)).then(r => r.data);
